export const product = {
    back: 'Back',
    loading: 'Loading product...',
    inStock: 'In stock',
    outOfStock: 'Out of stock',
    features: 'Features',
    specifications: 'Technical Specifications',
    warranty: 'Warranty',
    shipping: 'Shipping',
    specificationsLabels: {
        battery: 'Battery',
        flightTime: 'Flight Time',
        range: 'Range',
        weight: 'Weight',
        camera: 'Camera',
        gimbal: 'Gimbal',
        obstacleAvoidance: 'Obstacle Avoidance',
        maxSpeed: 'Max Speed',
        maxAltitude: 'Max Altitude',
    },
    notFound: {
        title: 'Product not found',
        description: 'The product you are looking for was not found.',
        backToCatalog: 'Back to catalog',
    },
    video: {
        title: 'Demo Video',
        description: 'Watch the drone in action and discover all its features',
    },
};
//# sourceMappingURL=product.js.map